/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Consumption status enumeration.
 */
export type ConsumptionStatus = typeof ConsumptionStatus[keyof typeof ConsumptionStatus];


export const ConsumptionStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
} as const;
